export const blockIconsAndroidBattery6BarNew = (
	<span className='material-symbols-outlined'>battery_6_bar</span>
);
